import { useNavigate } from 'react-router-dom';
import { Icon } from '../../utils/icons';
import { maskStyle } from '../../utils/icons';
import { useLang } from '../../i18n';

const SPORTS = [
  { id: 'volleyball',        labelKey: 'home.sports.volleyball',        icon: 'sport-volleyball',       color: '#ff8c42', path: '/volleyball' },
  { id: 'rugby',             labelKey: 'home.sports.rugby',             icon: 'sport-rugby',            color: '#c97c3a', path: '/rugby' },
  { id: 'american-football', labelKey: 'home.sports.americanFootball',  icon: 'sport-american-football', color: '#5bc4a0', path: '/american-football' },
  { id: 'handball',          labelKey: 'home.sports.handball',          icon: 'sport-handball',         color: '#9b7fe8', path: '/handball' },
  { id: 'mma',               labelKey: 'home.sports.mma',               icon: 'sport-mma',              color: '#e85c5c', path: '/mma' },
];

const css = `
  .moresports { padding: 4px 0 8px; }
  .moresports-title { font-size: 11px; font-weight: 700; letter-spacing: .8px; color: #5a5972; text-transform: uppercase; padding: 12px 16px 6px; }
  .moresports-row { display: flex; align-items: center; gap: 12px; height: 46px; padding: 0 16px; cursor: pointer; width: 100%; text-align: left; }
  .moresports-row:active { background: rgba(255,255,255,.04); }
  .moresports-dot { width: 32px; height: 32px; border-radius: 9px; display: grid; place-items: center; flex: none; }
  .moresports-label { font-size: 14px; font-weight: 500; color: #fff; flex: 1; }
  .moresports-chev { width: 6px; height: 11px; background: #5a5972; flex: none; }
  .moresports-sep { height: 1px; background: rgba(255,255,255,.05); margin: 0 16px; }
`;

export default function MoreSports() {
  const navigate = useNavigate();
  const { t } = useLang();
  return (
    <div className="moresports">
      <style>{css}</style>
      <div className="moresports-title">{t('home.moreSports')}</div>
      {SPORTS.map((s, i) => (
        <div key={s.id}>
          <button className="moresports-row" onClick={() => navigate(s.path)}>
            <span className="moresports-dot" style={{ background: s.color + '22' }}>
              <Icon name={s.icon} w={18} h={18} color={s.color} />
            </span>
            <span className="moresports-label">{t(s.labelKey)}</span>
            <span className="moresports-chev" style={maskStyle('ic-chevron')} />
          </button>
          {i < SPORTS.length - 1 && <div className="moresports-sep" />}
        </div>
      ))}
    </div>
  );
}
